var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-drawer',{attrs:{"visible":_vm.Visible,"size":"70%","title":"Auditoria Tarjeta"},on:{"update:visible":function($event){_vm.Visible=$event},"close":function($event){return _vm.$emit('VisibleFalse')}}},[_c('br'),_c('br'),_c('rabbey-table-3',{attrs:{"loading":_vm.Loading,"data":_vm.tableData,"columns":_vm.columns,"paginateFromApi":true,"paginationApi":{
      currentPage: _vm.paginaActual,
      pageSize: _vm.totalDeRegistrosPorPagina,
      total: _vm.registrosTotal
    },"class-table":{
      'table-box': true,
      'card-base': true,
      'card-shadow--medium': false
    }},on:{"update-page-size":_vm.handleSizeChange,"update-current-page":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }